import App from './App.svelte';

let app_class = ".wrap_tourPage"
const app = new App({
	target: document.querySelector(app_class),

});

export default app;